export class LoadingManager {
    static overlay = null;
    static isActive = false;

    /**
     * Блокирует экран и показывает анимацию загрузки
     * @param {string} message - Сообщение для отображения (опционально)
     */
    static show(message = 'Загрузка...') {
        if (this.isActive) {
            this.updateMessage(message);
            return;
        }

        this.overlay = document.createElement('div');
        this.overlay.className = 'loading-overlay';
        this.overlay.innerHTML = `
            <div class="loading-content">
                <div class="spinner-border text-light mb-3" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div class="loading-text">${message}</div>
            </div>
        `;

        // Добавляем стили если их еще нет
        if (!document.getElementById('loading-manager-styles')) {
            const styles = document.createElement('style');
            styles.id = 'loading-manager-styles';
            styles.textContent = `
                .loading-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                    backdrop-filter: blur(2px);
                }
                
                .loading-content {
                    text-align: center;
                }
                
                .loading-text {
                    color: white;
                    font-size: 1rem;
                    font-weight: 500;
                }
                
                .spinner-border {
                    width: 3rem;
                    height: 3rem;
                }
            `;
            document.head.appendChild(styles);
        }

        document.body.appendChild(this.overlay);
        this.isActive = true;

        // Блокируем скролл
        document.body.style.overflow = 'hidden';
    }

    /**
     * Убирает блокировку экрана и анимацию загрузки
     */
    static hide() {
        if (!this.isActive || !this.overlay) return;

        this.overlay.remove();
        this.overlay = null;
        this.isActive = false;

        // Возвращаем скролл
        document.body.style.overflow = '';
    }

    /**
     * Обновляет сообщение загрузки
     * @param {string} message - Новое сообщение
     */
    static updateMessage(message) {
        if (!this.isActive || !this.overlay) return;

        const textElement = this.overlay.querySelector('.loading-text');
        if (textElement) {
            textElement.textContent = message;
        }
    }

    /**
     * Проверяет, активна ли блокировка
     * @returns {boolean}
     */
    static get active() {
        return this.isActive;
    }
}
